<div class="screen-container">

  <div class="content-area d-flex flex-column align-items-center justify-content-center px-4 flex-grow-1">

    <div class="error-icon-box mb-5">
      <i class="fas fa-exclamation"></i>
    </div>

    <h1 class="error-title text-center mb-4" [innerHTML]="'error.404.title' | translate"></h1>

    <p class="error-message text-center" [innerHTML]="'error.404.description' | translate"></p>

    <button class="back-btn mt-4" (click)="goToHome()">
      <i class="fas fa-arrow-left mr-2"></i>{{ 'error.back_button' | translate }}
    </button>

  </div>

  <div class="praticko-footer text-center py-4">
    <h2 class="footer-brand mb-1">{{ 'common.brandName' | translate }}</h2>
    <small class="footer-sub d-block">{{ 'common.developedBy' | translate }}</small>
    <small class="footer-sub d-block">{{ 'common.versionInfo' | translate }}</small>
  </div>

</div>
